import Cookies from 'js-cookie';

const COOKIE_NAME = 'user_access_token';
const base = {
  sameSite: 'lax',
   secure: process.env.NODE_ENV === 'production',
  path: '/'
};

export const setAccessToken = (token, days = 2) =>
  Cookies.set(COOKIE_NAME, token, { ...base, expires: days });

export const getAccessToken = () => Cookies.get(COOKIE_NAME);

export const clearAccessToken = () =>
  Cookies.remove(COOKIE_NAME, { path: '/' });
